import nsApi from '@netsapiens/netsapiens-js/dist/api';
import _ from 'lodash';
import fetchBoardListService from './fetchBoardList';

export default async ({
  user,
  domain,
  board,
}) => new Promise((resolve) => {
  const data = {
    ...board,
    domain,
    user,
  };

  if (board.layouts) { data.layouts = JSON.stringify(board.layouts); }

  if (board.share_details) { data.share_details = JSON.stringify(board.share_details); }

  if (board.properties) { data.properties = JSON.stringify(board.properties); }

  nsApi.post({
    object: 'dashboard',
    action: 'create',
  }, {
    ...data,
    name: board.name,
    owner_type: 1, // 1: user
    owner_id: user,
    public_id: board.public_id,
  }).then(() => {
    fetchBoardListService({ domain }).then((boardList) => {
      const boards = _.sortBy(boardList, 'id').reverse();
      const newBoardId = boards[0].id;

      if (boards[0]) {
        // eslint-disable-next-line no-undef
        const secondPost = _.cloneDeep(boards[0]);
        secondPost.user = user;
        nsApi.post({ // Second api request to create , but with the id this time.
          object: 'dashboard',
          action: 'create',
        }, secondPost);
      }

      localStorage.setItem('boardID', newBoardId);

      resolve(newBoardId);
    }).catch((err) => {
      console.error(err);
      resolve(false);
    });
  }).catch((err) => {
    console.error(err);
    resolve(false);
  });
});
